// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wg5V","name":"styles_name__pVgQK","phone":"styles_phone__351Ls"};